import { render, staticRenderFns } from "./NetPaNav.vue?vue&type=template&id=06458a0a&scoped=true&"
import script from "./NetPaNav.vue?vue&type=script&lang=js&"
export * from "./NetPaNav.vue?vue&type=script&lang=js&"
import style0 from "./NetPaNav.vue?vue&type=style&index=0&id=06458a0a&scoped=true&lang=css&"
import style1 from "./NetPaNav.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06458a0a",
  null
  
)

export default component.exports